import styled from 'styled-components';
import { colors, fontSizes, fontWeights, spacing } from '../../../defaultTheme';
export const StyledBreadcrumbs = styled.nav `
  background-color: ${colors.turquoiseLightest};
  border-bottom: 1px solid ${colors.lightGrey};
  display: flex;
  padding: ${spacing.medium}px ${spacing.large}px;
  width: 100%;
`;
export const StyledBreadcrumbItem = styled.button `
  border: none;
  background-color: inherit;
  color: ${(props) => (props.active ? colors.black : colors.cyanBlue)};
  cursor: ${(props) => (!props.active ? 'pointer' : 'default')};
  font-family: 'Open Sans';
  font-size: ${fontSizes.root}px;
  font-weight: ${fontWeights.bold};
  padding: 0;
  &:hover {
    text-decoration: ${(props) => (props.active ? 'none' : 'underline')};
  }
  &::before {
    content: '${(props) => (props.active ? '/' : '')}';
    margin-left: 0;
    margin-right: ${(props) => (props.active ? `${spacing.small}px` : 0)};
    display: inline-block;
    text-decoration: none;
  }
`;
export const BackIconWrapper = styled.div `
  color: ${colors.cyanBlue};
  margin-right: ${spacing.small}px;
`;
export const StyledBreadcrumbWrapper = styled.div `
  display: flex;
  align-items: center;
  &:not(:first-child) {
    margin-left: ${spacing.small}px;
  }
`;
